<app-so-modal modalId="modal-detalle-mensajes" verticalposition="center" size="modal-full-page" (click)="onClose()"
  [preventClose]="true">


  <div class="modal__header" [style]="{'display':'flex','width':'100%','margin-top':'30px'}">

  </div>
  <!-- End Modal header -->


  <div class="modal__body" [style]="{'padding':'0px'}">
    <iframe [src]="url | safeUrl" frameborder="0"></iframe>

    <div class="footer-modal">

    </div>
  </div>


</app-so-modal>
